import React, { useState, useEffect, useContext } from 'react';
import { useParams, useLocation, useHistory, Prompt } from "react-router-dom";
import { useDispatch } from 'react-redux'
import queryString from 'query-string';
import { LinkContainer } from 'react-router-bootstrap';
import { Card, Button, Dropdown, ButtonGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronCircleRight, faDownload } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment-business-days';
import { TabItem, TabList } from '../../controls/';
import { modalActionCreator, dispatchOverrideSpinner } from '../../store/actions/';
import { CodingEventService, CodingWorksheetService } from '../../services';
import { useFormik } from 'formik';
import * as Yup from "yup";
import _ from 'lodash';
import parse from "html-react-parser"

import { claims, claimValues } from '../../utilities/authConstants';
import CodingEventDocuments from './form/CodingEventDocuments';
import CodingEventNotes from './form/CodingEventNotes';
import CodingEventForm from './form/CodingEventForm';
import { codingEventInitData, codingEventValidationSchema } from './form/CodingEvent.Code';
import { useImmer } from 'use-immer';
import { ConditionalRender } from '../../controls/formControls';
import { BusyButton } from '../../controls/Buttons';
import { CodingEventQueueContext } from '../../contexts/CodingEventQueueContext';
import AudienceList from '../../controls/message/AudienceList';
import MessageList from '../../controls/message/MessageList';
import { AuthContext } from '../../contexts/AuthContext';
import CodingEventStartReply from '../../controls/message/CodingEventStartReply';
import JoinLeaveMessageAudience from '../../controls/message/JoinLeaveMessageAudience';
import CodingWorksheetPrint from '../codingworksheet/CodingWorksheetPrint';


const CodingEvent = (props) => {
    const [returnUrl, setReturnUrl] = useState('');
    const [currentUserId, setCurrentUserId] = useState();
    const [codingEvent, setCodingEvent] = useImmer(codingEventInitData);
    const [refData, setRefData] = useImmer({
        codingEventQueues: [],
        customerAccount: [],
        priorities: [],
        statuses: [],
        contacts: [],
        users: [],
        services: [],
        clinicians: [],
        clinicalManagers: []
    });

    const codingEventContext = useContext(CodingEventQueueContext);
    const authContext = useContext(AuthContext);

    const dispatch = useDispatch();

    let { id } = useParams();
    let location = useLocation();
    let history = useHistory();

    useEffect(() => {
        let returnUrl = queryString.parse(location.search).returnUrl;
        if (returnUrl !== undefined) {
            setReturnUrl(returnUrl);
        }
    }, []);

    useEffect(() => {
        if (id !== undefined) {
            getCodingEvent(id);
            setCurrentUserId(authContext.currentUser.id);
        }
    }, [id])

    const getCodingEvent = async (id) => {
        var eventService = new CodingEventService();
        var results = await eventService.getEvent(id);
        if (results.result) {
            const codingEvent = results.model.codingEvent;
            codingEvent.newNote = '';
            setCodingEvent(codingEvent);
            setRefData(_.omit(results.model, "codingEvent"));
        } else {
            //set some error srate here?
        }
    }

    const goBack = () => {
        if (returnUrl != '') {
            history.push(returnUrl);
        } else {
            history.goBack();
        }
    }

    const createWorksheet = async (masterWorksheetId) => {
        var eventService = new CodingWorksheetService();
        var params = { masterWorksheetId: masterWorksheetId, codingEventId: codingEvent.id, accountId: codingEvent.accountId };
        var callResult = await eventService.createWorksheet(params);
        if (callResult.result) {
            //go to the worksheet
            history.push('/coding/worksheet/' + callResult.model.id);
        }
    }

    const printWorksheet = async (id) => {

        var eventService = new CodingWorksheetService();
        var callResult = await eventService.getWorksheet(id);

        if (callResult.result) {
            let vm = callResult.model.codingEventWorksheet;
            var info = vm.worksheetAnswers.information;
            var title = "Undefined"
            var modalTitle = ""
            if (info != undefined) {
                var accountName = (info.accountName ?? "").replaceAll(' ', '-')
                var accountId = (info.accountId ?? "")
                var assessmentDate = (info.ASSESSMENT_DATE ?? "NULL");
                var oasisType = (info.OASIS_TYPE ?? "NULL").replaceAll(' ', '-')
                var patientIdMrn = (info.PATIENT_ID_MRN ?? "NULL").replaceAll(' ', '-')
                var clinician = (info.AUTHORING_CLINICIAN ?? "NULL").replaceAll(' ', '-')
                title = `${accountName}_${accountId}_${assessmentDate}_${oasisType}_${patientIdMrn}_${clinician}`
                modalTitle = `${(info.accountName ?? "NULL")} ${accountId} ${assessmentDate} ${(info.OASIS_TYPE ?? "NULL")} ${(info.PATIENT_ID_MRN ?? "NULL")} ${(info.AUTHORING_CLINICIAN ?? "NULL")}`
            }

            var controlToPrint = <CodingWorksheetPrint worksheet={vm.worksheet} answers={vm.worksheetAnswers} />;

            showModal({
                open: true,
                documentTitle: title,
                title: modalTitle,
                controlToPrint: controlToPrint,
                modalClassName: "modal-xxl",
                closeModal: hideModal
            }, 'printViewModal')
        }
    }

    const addNote = (note) => {
        setCodingEvent(draft => {
            draft.notes.push(note);
        });
    }

    const removeNote = (id) => {
        setCodingEvent(draft => {
            draft.notes = draft.notes.filter(note => note.id !== id);
        });
    }

    const addFile = (file) => {
        setCodingEvent(draft => {
            draft.documents.push(file);
        });
    }

    const removeFile = (id) => {
        setCodingEvent(draft => {
            draft.documents = draft.documents.filter(doc => doc.id !== id);
        });
    }

    const saveEvent = async (event) => {
        var eventService = new CodingEventService();
        var result = await eventService.saveEvent(event);
        if (result.result) {
            await getCodingEvent(event.id);
            //const codingEvent = result.model;
            //codingEvent.newNote = '';

            //setCodingEvent(codingEvent);
            codingEventContext.getCodingEvents();
        } else {
            showModal({
                open: true,
                message: "Failed to save the coding event.",
                title: 'Error',
                model: refData.customerAccount,
                closeModal: hideModal
            }, 'errorModal')
        }
        //setTimeout(() => {
        //}, 10000)
    }

    const formik = useFormik({
        initialValues: codingEvent,
        validationSchema: Yup.object().shape(codingEventValidationSchema),
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            await saveEvent(values);
            setSubmitting(false);
        }
    });

    const submitForm = () => {
        if (!_.isEmpty(formik.errors)) {
            const errors = Object.keys(formik.errors).map(errorKey => {
                formik.setFieldTouched(errorKey, true);
                return formik.errors[errorKey];
            })
            const errorString = parse(_.join(errors, '<br/>'));

            showModal({
                open: true,
                message: errorString,
                title: 'Validation Errors!',
                model: refData.customerAccount,
                closeModal: hideModal
            }, 'errorModal')
        } else {
            formik.submitForm();
        }
    }

    const addToRefData = (refDataName, value) => {
        let newRef = { id: value.id, name: value.fullName, value: value.id, label: value.fullName }
        setRefData(draft => {
            var index = _.findIndex(draft[refDataName], { id: newRef.id });
            if (index > 0) {
                draft[refDataName].splice(index, 1, newRef);
            } else {
                draft[refDataName].push(newRef);
            }
            draft[refDataName] = draft[refDataName].sort((a, b) => (a.name.split(' ')[1].toLowerCase() > b.name.split(' ')[1].toLowerCase()) ? 1 : -1)
        })
    }

    const messageChangedCallback = async () => {
        await getCodingEvent(id);
        authContext.hideModal();
    }

    const showModal = (props, type) => {
        dispatch(modalActionCreator.showModal(props, type));
    }

    const hideModal = () => {
        dispatch(modalActionCreator.hideModal());
    }
    
    return (
        <>
            <Card>
                <Card.Header className="d-flex align-items-center">
                    <Prompt
                        when={formik.dirty}
                        message="You have unsaved changes, are you sure you want to leave?"
                    />
                    <div className="mr-auto">{"Coding Event #: " + codingEvent.id + " - "} {codingEvent.description.length > 80 ? (codingEvent.description.substring(0, 80) + " ...") : codingEvent.description}</div>

                    <div className="card-btn-group">
                        <Button variant="primary" size="sm" onClick={() => showModal({
                            open: true,
                            size: "lg",
                            model: refData.customerAccount,
                            hideModal: hideModal
                        }, 'customerProfile')}>Coding Profile</Button>
                        <ConditionalRender visible={!formik.dirty}>
                            <Button variant="secondary" size="sm" onClick={() => goBack()}>Close</Button>
                        </ConditionalRender>
                        <ConditionalRender visible={formik.dirty}>
                            <Button variant="secondary" size="sm" onClick={formik.handleReset}>Undo Changes</Button>
                            <BusyButton variant="success" size="sm" loading={formik.isSubmitting} onClick={submitForm}>Save</BusyButton>
                            {/*<Button variant="success" size="sm" onClick={submitForm}>Save</Button>  disabled={!_.isEmpty(formik.errors) } */}
                        </ConditionalRender>

                    </div>
                </Card.Header>
                <Card.Body>
                    <CodingEventForm
                        formHandler={formik}
                        refData={refData}
                        showModal={showModal}
                        hideModal={hideModal}
                        addToRefData={addToRefData}
                    />
                    <div className="d-flex align-items-center">
                        <div className="mr-auto"><b>Associated Worksheets</b></div>
                        <div className="card-btn-group">
                            <Dropdown as={ButtonGroup} size="sm">
                                <Button variant="primary" size="sm" disabled>Start New Worksheet</Button>
                                <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                                <Dropdown.Menu>
                                    <Dropdown drop='left'>
                                        <Dropdown.Toggle variant="light" id="dropdown-basic-oasis-d">
                                            Oasis D Worksheets
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => createWorksheet(1)}>Oasis D SOC/ROC Worksheet</Dropdown.Item>
                                            <Dropdown.Item onClick={() => createWorksheet(4)}>Oasis D DC Worksheet</Dropdown.Item>
                                            <Dropdown.Item onClick={() => createWorksheet(5)}>Oasis D Review Recert Worksheet</Dropdown.Item>
                                            <Dropdown.Item onClick={() => createWorksheet(6)}>Oasis D POC Recert Worksheet</Dropdown.Item>
                                            <Dropdown.Item onClick={() => createWorksheet(7)}>Oasis D POC SOC Worksheet</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <Dropdown drop='left'>
                                        <Dropdown.Toggle variant="light" id="dropdown-basic-oasis-e">
                                            Oasis E Worksheets
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => createWorksheet(9)}>Oasis E SOC/ROC Worksheet</Dropdown.Item>
                                            <Dropdown.Item onClick={() => createWorksheet(12)}>Oasis E SOC POC Worksheet</Dropdown.Item>
                                            <Dropdown.Item onClick={() => createWorksheet(10)}>Oasis E Recert Worksheet</Dropdown.Item>
                                            <Dropdown.Item onClick={() => createWorksheet(11)}>Oasis E Recert POC Worksheet</Dropdown.Item>
                                            <Dropdown.Item onClick={() => createWorksheet(13)}>Oasis E DC Worksheet</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <Dropdown.Item onClick={() => createWorksheet(2)}>Home Health Coding Worksheet</Dropdown.Item>
                                    <Dropdown.Item onClick={() => createWorksheet(3)}>Hospice Coding Worksheet</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                    <div>
                        <table className='table' aria-labelledby="tabelLabel">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Version</th>
                                    <th>Started On</th>
                                    <th>Status</th>
                                    <th className="table-fit"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {codingEvent.worksheets.map((worksheet) =>
                                    <tr key={worksheet.id}>
                                        <td>{worksheet.name}</td>
                                        <td>{worksheet.version}</td>
                                        <td>{moment(worksheet.dateCreated).format('MM/DD/YYYY h:mm a')}</td>
                                        <td>{worksheet.statusName}</td>
                                        <td className="table-fit text-right">
                                            <FontAwesomeIcon icon={faDownload} className={worksheet.status != 10 ? "d-none" : "primary-icon"} onClick={() => window.open("/coding/worksheet/print/" + worksheet.id, "_blank")} />&nbsp;
                                            <LinkContainer to={'/coding/worksheet/' + worksheet.id}>
                                                <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
                                            </LinkContainer>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div><br /><br />
                    <TabList>
                        <TabItem label="Case Notes">
                            <CodingEventNotes
                                notes={codingEvent.notes}
                                codingEventId={codingEvent.id}
                                onNoteAdded={(note) => addNote(note)}
                                onNoteDeleted={(id) => removeNote(id)}
                                formHandler={formik}
                            />
                        </TabItem>
                        <TabItem label="Associated Files" isTable>
                            <CodingEventDocuments
                                documents={codingEvent.documents}
                                codingEventId={codingEvent.id}
                                onFileDeleted={(id) => removeFile(id)}
                                onFileAdded={(file) => addFile(file)}
                            />
                        </TabItem>
                        <TabItem label="Messages" isTable>
                            <AudienceList message={codingEvent?.message} updateCallback={messageChangedCallback}>
                                <JoinLeaveMessageAudience message={codingEvent?.message} currentUserId={currentUserId} updateCallback={messageChangedCallback} />
                                <CodingEventStartReply currentUserId={currentUserId} messageChangedCallback={messageChangedCallback} codingEvent={codingEvent} />
                            </AudienceList>
                            <MessageList message={codingEvent?.message} currentUserId={currentUserId} />
                        </TabItem>
                    </TabList>
                </Card.Body>
            </Card>
        </>
    )
}

export default CodingEvent;